module.exports = __webpack_public_path__ + "media/bootstrap-icons/pin-map-fill-446db35c.svg";